import React, { createContext, useContext, useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { login as apiLogin, fetchMe } from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("sq_admin_token"));
  const [email, setEmail] = useState(localStorage.getItem("sq_admin_email"));
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const verify = async () => {
      if (token) {
        try {
          await fetchMe();
        } catch (e) {
          logout();
        }
      }
      setReady(true);
    };
    verify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (em, password) => {
    const data = await apiLogin(em, password);
    localStorage.setItem("sq_admin_token", data.access_token);
    localStorage.setItem("sq_admin_email", data.email);
    setToken(data.access_token);
    setEmail(data.email);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("sq_admin_token");
    localStorage.removeItem("sq_admin_email");
    setToken(null);
    setEmail(null);
  };

  return (
    <AuthContext.Provider value={{ token, email, login, logout, isAuthed: !!token, ready }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const RequireAuth = ({ children }) => {
  const { isAuthed, ready } = useAuth();
  const location = useLocation();
  if (!ready) {
    return <div className="min-h-screen flex items-center justify-center text-gray-400">Caricamento...</div>;
  }
  if (!isAuthed) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
};
